
import "./less/style.less";

// api test

// import axios from "axios";
// axios.get("http://localhost:9090/api/index.php/token").then((r) => {
//   console.log(r);
// });


import u from "./lib/u";

u.applyIcons(".e-icon");
u.applyViewport();
u.handleSpMenu();
u.applyScrollUp();
u.applyAnchorActions();

import view from "./lib/view";



// WEBPACK FOOTER //
// ./src/main.js